<template>
	<p v-if="loading" class="state-message">{{ loadingMessage }}</p>
	<p v-else-if="error" class="state-message error">{{ errorMessage }}</p>
	<p v-else-if="empty" class="state-message">{{ emptyMessage }}</p>
	<slot v-else></slot>
</template>

<script setup lang="ts">
defineProps<{
	loading: boolean
	error: boolean
	empty: boolean
	loadingMessage: string
	errorMessage: string
	emptyMessage: string
}>()
</script>

<style scoped>
.state-message {
	margin: 0;
	padding: var(--spacing-lg);
	border: var(--border-width-thin) solid var(--neutral-200);
	border-radius: var(--border-radius-lg);
	color: var(--neutral-500);
	font-size: var(--font-size-small);
	text-align: center;

	&.error {
		color: var(--accent-warning);
	}
}
</style>
